
import {createElement, FC, Fragment} from 'react';
import {TrackLink} from 'components/Markdown/Link';
import rehypeRaw from 'rehype-raw';
import rehypeReact from 'rehype-react';
import remarkBreaks from 'remark-breaks';
import remarkParse from 'remark-parse';
import remarkLint from 'remark-preset-lint-recommended';
import remarkRehype from 'remark-rehype';
import {unified} from 'unified';

import remarkParagraphsOnly from './remarkParagraphsOnly';
import remarkUnlink from './remarkUnlink';

type PostTextProps = {
	markdown: string
}

export const PostText: FC<PostTextProps> = ({markdown}) => (
	unified()
		.use(remarkParse)
		.use(remarkLint)
		.use(remarkBreaks)
		.use(remarkParagraphsOnly)
		.use(remarkUnlink)
		.use(remarkRehype)
		.use(rehypeRaw)
		.use(rehypeReact, {
			...{createElement, Fragment},
			components: {
				a: TrackLink('blog:desc'),
			}
		})
		.processSync(markdown)
		.result
);
